const getModuleState = state => state.drive;

export const isUploading = state => getModuleState(state).uploading;
export const getCurrentFolder = state => getModuleState(state).currentFolder;
export const getCurrentFolderId = state => getModuleState(state).currentFolderId;
export const getFolderTree = state => getModuleState(state).folderTree;
export const isDraggingItem = state => getModuleState(state).draggingItem;
export const getUploadQueue = state => getModuleState(state).uploadQueue;
export const getUploadingFile = state => getModuleState(state).uploadingFile;
export const getUploadProgress = state => getModuleState(state).uploadProgress;
export const getUploadSpeed = state => getModuleState(state).uploadSpeed;
export const getUploadTimeLeft = state => getModuleState(state).uploadTimeLeft;
export const getTrashItems = state => getModuleState(state).trashItems;
